export default __webpack_public_path__ + "static/media/Bannerlastmob.79ffbe0d.png";